import { Flex } from 'antd';

import { CHART_DIMENSIONS } from './const';

const TAB_SELECTABLE = 0;
const NOT_TAB_SELECTABLE = -1;

/**
 * Returns goals index chart component using Raphael.js
 */
export function IndexChartFrame({
  paperRef,
  text,
  ...opts
}: {
  paperRef: React.RefObject<HTMLDivElement>;
  text: {
    title: string;
    sectorTitle: string;
    description: string;
  };
  showLegend?: boolean;
  readonly onChartClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
}): JSX.Element {
  return (
    <Flex
      align="flex-start"
      justify="center"
      gap="30px"
      style={{ flexDirection: 'row' }}
    >
      <div
        id="goalsIndex"
        ref={paperRef}
        style={{
          width: `${CHART_DIMENSIONS.width}px`,
          height: `${CHART_DIMENSIONS.height}px`,
        }}
        onClick={(e) => opts.onChartClick?.(e)}
        // accessibility
        aria-label={text.title}
        role={opts.onChartClick ? 'button' : 'figure'}
        tabIndex={opts.onChartClick ? TAB_SELECTABLE : NOT_TAB_SELECTABLE}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            opts.onChartClick?.(e);
          }
        }}
      />
      {opts.showLegend && (
        <Flex
          vertical
          justify="center"
          gap="10px"
          className="index-chart-legend"
        >
          <h4 className="text-primary fw-bold">{text.title}</h4>
          {text.sectorTitle && (
            <h5 className="text-primary fw-bold">{text.sectorTitle}</h5>
          )}
          <p>{text.description}</p>
        </Flex>
      )}
    </Flex>
  );
}
